@if (participations.length > 0) {
    <div class="card mt-4">
        <div class="flex flex-wrap items-start justify-between gap-3 mb-1">
            <div>
                <div class="text-xl font-semibold">Teilnahmeabzeichen</div>
                <p class="text-muted-color text-sm">
                    Eine Auszeichnung für jede abgeschlossene Saison mit Renneinsatz. Wer eine Saison
                    komplett bestritten hat, erhält das goldene 100%-Abzeichen.
                </p>
            </div>
            @if (playerId) {
                <div class="flex items-center gap-2 shrink-0">
                    <span class="text-muted-color text-sm">Linkgröße</span>
                    <p-selectbutton
                        [options]="sizeOptions"
                        [(ngModel)]="size"
                        optionLabel="label"
                        optionValue="value"
                        [allowEmpty]="false"
                        size="small"
                    />
                </div>
            }
        </div>

        <div class="flex flex-wrap gap-4 mt-4">
            @for (p of participations; track p.season_id) {
                <div
                    class="badge-item"
                    [title]="p.season_name + ' – ' + p.race_count + (p.total_races > 0 ? '/' + p.total_races : '') + ' Rennen'"
                >
                    <app-season-badge [seasonNumber]="p.season_number" [complete]="p.is_complete" />
                    <div class="badge-caption" [class.complete]="p.is_complete">
                        @if (p.total_races > 0) {
                            {{ p.race_count }}/{{ p.total_races }} Rennen
                        } @else {
                            {{ p.race_count }} Rennen
                        }
                        @if (p.is_complete) {
                            <i class="pi pi-verified" aria-hidden="true"></i>
                        }
                    </div>
                    @if (playerId) {
                        <p-button
                            [icon]="copiedSeasonId === p.season_id ? 'pi pi-check' : 'pi pi-link'"
                            [label]="copiedSeasonId === p.season_id ? 'Kopiert' : 'Link'"
                            severity="secondary"
                            size="small"
                            [text]="true"
                            (onClick)="copyLink(p.season_id)"
                            pTooltip="Statischen SVG-Link kopieren"
                            tooltipPosition="bottom"
                        />
                    }
                </div>
            }
        </div>
    </div>
}
